const oldTeamData = [
  {
    draws: 2,
    goal_conceded: 8,
    goal_scored: 15,
    last_five: [],
    losses: 1,
    matchesPlayed: 8,
    name: "Carron Capitals",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/carron_team.JPG",
    sponsor_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/carron_sponsor.png",
    players: [
      "683aa5533b190fbe800da0c6",
      "683aa5533b190fbe800da0c7",
      "683aa5533b190fbe800da0c8",
      "683aa5533b190fbe800da0c9",
      "683aa5533b190fbe800da0ca",
      "683aa5533b190fbe800da0cb",
      "683aa5533b190fbe800da0cc",
      "683aa5533b190fbe800da0cd",
      "683aa5533b190fbe800da0ce",
      "683aa5533b190fbe800da0cf",
      "683aa5533b190fbe800da0d0",
      "683aa5533b190fbe800da0d1",
      "683aa5533b190fbe800da0d2",
      "683aa5533b190fbe800da0d3",
      "683aa5533b190fbe800da0d4",
      "683aa5533b190fbe800da0d5",
    ],
    season: 2025,
    wins: 5,
    __v: 0,
    _id: "683aa5453b190fbe800da086",
  },
  {
    draws: 1,
    goal_conceded: 15,
    goal_scored: 10,
    last_five: [],
    losses: 4,
    matchesPlayed: 7,
    name: "Gala Legends",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.amazonaws.com/Vagad_League/teams/gala_team.png",
    sponsor_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.amazonaws.com/Vagad_League/teams/gala_sponsor.png",
    players: [
      "683aa5533b190fbe800da0f3",
      "683aa5533b190fbe800da0f4",
      "683aa5533b190fbe800da0f5",
      "683aa5533b190fbe800da0f6",
      "683aa5533b190fbe800da0f7",
      "683aa5533b190fbe800da0f8",
      "683aa5533b190fbe800da0f9",
      "683aa5533b190fbe800da0fa",
      "683aa5533b190fbe800da0fb",
      "683aa5533b190fbe800da0fc",
      "683aa5533b190fbe800da0fd",
      "683aa5533b190fbe800da0fe",
      "683aa5533b190fbe800da0ff",
      "683aa5533b190fbe800da100",
      "683aa5533b190fbe800da101",
    ],
    season: 2025,
    wins: 2,
    __v: 0,
    _id: "683aa5453b190fbe800da082",
  },
  {
    draws: 1,
    goal_conceded: 14,
    goal_scored: 7,
    last_five: [],
    losses: 5,
    matchesPlayed: 7,
    name: "Vandana Warriors",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/vandana_team.png",
    sponsor_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/vandana_sponsor.jpg",
    players: [
      "683aa5533b190fbe800da0d6",
      "683aa5533b190fbe800da0d7",
      "683aa5533b190fbe800da0d8",
      "683aa5533b190fbe800da0d9",
      "683aa5533b190fbe800da0da",
      "683aa5533b190fbe800da0db",
      "683aa5533b190fbe800da0dc",
      "683aa5533b190fbe800da0dd",
      "683aa5533b190fbe800da0de",
      "683aa5533b190fbe800da0df",
      "683aa5533b190fbe800da0e0",
      "683aa5533b190fbe800da0e1",
      "683aa5533b190fbe800da0e2",
      "683aa5533b190fbe800da0e3",
      "683aa5533b190fbe800da0e4",
      "683aa5533b190fbe800da0e5",
    ],
    season: 2025,
    wins: 1,
    __v: 0,
    _id: "683aa5453b190fbe800da083",
  },
    {
    draws: 3,
    goal_conceded: 8,
    goal_scored: 10,
    last_five: [],
    losses: 2,
    matchesPlayed: 8,
    name: "Sagar Seahawks",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.amazonaws.com/Vagad_League/teams/sagar_team.png",
    sponsor_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/sagar_sponsor.jpeg",
    players: [
      "683aa5533b190fbe800da0b6",
      "683aa5533b190fbe800da0b7",
      "683aa5533b190fbe800da0b8",
      "683aa5533b190fbe800da0b9",
      "683aa5533b190fbe800da0ba",
      "683aa5533b190fbe800da0bb",
      "683aa5533b190fbe800da0bc",
      "683aa5533b190fbe800da0bd",
      "683aa5533b190fbe800da0be",
      "683aa5533b190fbe800da0bf",
      "683aa5533b190fbe800da0c0",
      "683aa5533b190fbe800da0c1",
      "683aa5533b190fbe800da0c2",
      "683aa5533b190fbe800da0c3",
      "683aa5533b190fbe800da0c4",
      "683aa5533b190fbe800da0c5",
    ],
    season: 2025,
    wins: 3,
    __v: 0,
    _id: "683aa5453b190fbe800da087",
  },
  {
    draws: 2,
    goal_conceded: 7,
    goal_scored: 7,
    last_five: [],
    losses: 3,
    matchesPlayed: 8,
    name: "Sakori Smashers",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/sakori_team.jpg",
    sponsor_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/sakori_sponsor.jpg",
    players: [
      "683aa5533b190fbe800da0a6",
      "683aa5533b190fbe800da0a7",
      "683aa5533b190fbe800da0a8",
      "683aa5533b190fbe800da0a9",
      "683aa5533b190fbe800da0aa",
      "683aa5533b190fbe800da0ab",
      "683aa5533b190fbe800da0ac",
      "683aa5533b190fbe800da0ad",
      "683aa5533b190fbe800da0ae",
      "683aa5533b190fbe800da0af",
      "683aa5533b190fbe800da0b0",
      "683aa5533b190fbe800da0b1",
      "683aa5533b190fbe800da0b2",
      "683aa5533b190fbe800da0b3",
      "683aa5533b190fbe800da0b4",
      "683aa5533b190fbe800da0b5",
    ],
    season: 2025,
    wins: 3,
    __v: 0,
    _id: "683aa5453b190fbe800da088",
  },
  {
    draws: 1,
    goal_conceded: 9,
    goal_scored: 6,
    last_five: [],
    losses: 4,
    matchesPlayed: 7,
    name: "Mango Marvels",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/mango_team.png",
    sponsor_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/mango_sponsor.png",
    players: [
      "683aa5533b190fbe800da0e6",
      "683aa5533b190fbe800da0e7",
      "683aa5533b190fbe800da0e8",
      "683aa5533b190fbe800da0e9",
      "683aa5533b190fbe800da0ea",
      "683aa5533b190fbe800da0eb",
      "683aa5533b190fbe800da0ec",
      "683aa5533b190fbe800da0ed",
      "683aa5533b190fbe800da0ee",
      "683aa5533b190fbe800da0ef",
      "683aa5533b190fbe800da0f0",
      "683aa5533b190fbe800da0f1",
      "683aa5533b190fbe800da0f2",
    ],
    season: 2025,
    wins: 2,
    __v: 0,
    _id: "683aa5453b190fbe800da081",
  },
    {
    draws: 3,
    goal_conceded: 7,
    goal_scored: 7,
    last_five: [],
    losses: 2,
    matchesPlayed: 7,
    name: "Sejal Scorchers",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/sejal_team.jpg",
    sponsor_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/sejal_sponsor.png",
    players: [
      "683aa5533b190fbe800da098",
      "683aa5533b190fbe800da099",
      "683aa5533b190fbe800da09a",
      "683aa5533b190fbe800da09b",
      "683aa5533b190fbe800da09c",
      "683aa5533b190fbe800da09d",
      "683aa5533b190fbe800da09e",
      "683aa5533b190fbe800da09f",
      "683aa5533b190fbe800da0a0",
      "683aa5533b190fbe800da0a1",
      "683aa5533b190fbe800da0a2",
      "683aa5533b190fbe800da0a3",
      "683aa5533b190fbe800da0a4",
      "683aa5533b190fbe800da0a5",
    ],
    season: 2025,
    wins: 2,
    __v: 0,
    _id: "683aa5453b190fbe800da085",
  },
  {
    draws: 3,
    goal_conceded: 5,
    goal_scored: 11,
    last_five: [],
    losses: 1,
    matchesPlayed: 8,
    name: "Bellicosa FC",
    team_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/bellicosa_team.jpeg",
    sponsor_logo:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/bellicosa_sponsor.jpg",
    players: [
      "683aa5533b190fbe800da08a",
      "683aa5533b190fbe800da08b",
      "683aa5533b190fbe800da08c",
      "683aa5533b190fbe800da08d",
      "683aa5533b190fbe800da08e",
      "683aa5533b190fbe800da08f",
      "683aa5533b190fbe800da090",
      "683aa5533b190fbe800da091",
      "683aa5533b190fbe800da092",
      "683aa5533b190fbe800da093",
      "683aa5533b190fbe800da094",
      "683aa5533b190fbe800da095",
      "683aa5533b190fbe800da096",
      "683aa5533b190fbe800da097",
    ],
    season: 2025,
    wins: 4,
    __v: 0,
    _id: "683aa5453b190fbe800da084",
  },
];

export default oldTeamData;